'use strict';

var formValidation = require('base/components/formValidation');

/**
 * Hides the select element based on counrty select
 * @param {jqueryObject} $selectElement - the select form element
 */
function hideStateProvince($selectElement) {
    $selectElement.addClass('d-none');
    $selectElement.find('select').removeAttr('required').removeClass('required');
    $selectElement.removeClass('required');
}

/**
 * Shows the select element based on counrty select
 * @param {jqueryObject} $selectElement - the select form element
 */
function showStateProvience($selectElement) {
    $selectElement.removeClass('d-none');
    $selectElement.find('select').prop('required', true).addClass('required');
    $selectElement.addClass('required');
}

module.exports = {
    submitProduct: function () {
        $('form.register-product-form').submit(function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr('action');
            $form.spinner().start();

            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        formValidation($form, data);
                    } else {
                        location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $form.spinner().stop();
                }
            });
            return false;
        });
    },
    // show or hide state/province field
    showHideStates: function () {
        var $stateFormGroup = $('.state-form-group');
        $('select[name$="_country"]').val('US');
        var $provinceFormGroup = $('.province-form-group');
        hideStateProvince($provinceFormGroup);
        $('select[name$="_country"]').on('change', function () {
            if (this.value === 'US') {
                showStateProvience($stateFormGroup);
                if (!$provinceFormGroup.hasClass('d-none')) {
                    hideStateProvince($provinceFormGroup);
                }
            } else if (this.value === 'CA') {
                showStateProvience($provinceFormGroup);
                if (!$stateFormGroup.hasClass('d-none')) {
                    hideStateProvince($stateFormGroup);
                }
            } else if (!$stateFormGroup.hasClass('d-none')) {
                hideStateProvince($stateFormGroup);
            } else if (!$provinceFormGroup.hasClass('d-none')) {
                hideStateProvince($provinceFormGroup);
            }
        });
    }
};
